import React, { useRef } from "react";
import emailjs from "@emailjs/browser";

import "./COntact.css";
import { toast } from "react-toastify";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    console.log(form.current);

    emailjs
      .sendForm(
        'service_k8a1m4m',
        'template_2kywyhh',
        form.current,
        '1G2Rl1r0kNM_VaDzs'
      )
      .then(
        (result) => {
          console.log(result.text);
          console.log("message sent");
          toast.success("Your Message is sent to Tanvir Ahmad Jesan");
          e.target.reset();
        },
        (error) => {
          console.log(error.text);
          toast.error("Something went wrong please try again");
          e.target.reset();
        }
      );
  };
  return (
    <div className="my-8" id="contact">
      <div className="text-center py-8">
        <h3 className="text-center text-3xl uppercase my-8 underline decoration-solid">
          Get In Touch
        </h3>
      </div>

      <div className="check">
        <div className="card w-full check">
          <div className="card-body bg-no-repeat">
            <form ref={form} onSubmit={sendEmail}>
              <div className="flex flex-col mx-auto">
                <div className="flex lg:flex-row md: flex-col justify-center items-center lg:gap-2 ">
                  <div className="form-control w-full max-w-2xl">
                    <label className="label">
                      <span className="label-text font-bold">Your Name</span>
                    </label>

                    <input
                      type="text"
                      name="name"
                      required
                      placeholder="Your Name"
                      className="input input-bordered w-50 max-w-2xl"
                    />
                  </div>
                </div>
                <div className="flex justify-center items-center gap-2"></div>
                <div className="flex items-center justify-center">
                  <div className="form-control w-full max-w-2xl">
                    <label className="label">
                      <span className="label-text font-bold">
                        Your Email Address
                      </span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      required
                      placeholder="Your Email"
                      className="input input-bordered w-full max-w-2xl"
                    />
                  </div>
                </div>
                <div className="flex items-center justify-center">
                  <div className="form-control w-full max-w-2xl">
                    <label className="label">
                      <span className="label-text font-bold">Your Message</span>
                    </label>
                    <textarea
                      type="text"
                      name="message"
                      required
                      placeholder="Your Message"
                      className="input input-bordered w-full h-40 "
                    />
                  </div>
                </div>

                <div className="flex justify-center items-center my-8">
                  <input
                    className="btn button w-full max-w-xs text-white"
                    type="submit"
                    value="Send Message"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default Contact;
